import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const FaqService = {
  // Define your API functions here
  createGroup: async (data) => {
    const response = await apiService.post("/faqgroup", data);
    return response.data;
  },
  create: async (data) => {
    const response = await apiService.post("/faq", data);
    return response.data;
  },
  updateGroup: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/faqgroup/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async () => {
    // const params = new URLSearchParams({
    //   ...(search && { search }),
    //   ...(status && { status }),

    //   page: page.toString(),
    //   pageSize: pageSize.toString(),
    // });

    const response = await apiService.get(`/faq/grouped`);
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/faqgroup/${id}`);
    return response.data;
  },
  getDetailFaq: async (id) => {
    const response = await apiService.get(`/faq/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/faqgroup/${id}`);
    return response.data;
  },
  deleteFaq: async (id) => {
    const response = await apiService.delete(`/faq/${id}`);
    return response.data;
  },
};

export default FaqService;
